// © Microsoft Corporation. All rights reserved.

import { ActivityData } from "@msnews/social-data-service";
import React from "react";
import { UsersConnector } from "../../Social.props";
import loadObserver from "../../utils/ObserverHelper";

export interface ProfileActivityReadMarkerProps {
    activity: ActivityData;
    usersConnector: UsersConnector;
    activityItemRef: HTMLLIElement;
}

interface ProfileActivityReadMarkerState {
    alreadyMarkedAsRead: boolean
}

export default class ProfileActivityReadMarker extends React.Component<ProfileActivityReadMarkerProps, ProfileActivityReadMarkerState> {
    observer: IntersectionObserver;

    constructor(props) {
        super(props);
        loadObserver(() => {
            this.observer = !this.props.activity.isSeen && new IntersectionObserver(this.componentInView.bind(this), {
                threshold: 1.0
            });
        });

        this.state = {alreadyMarkedAsRead: false};
    }

    componentDidMount() {
        this.observer && this.observer.observe(this.props.activityItemRef);
    }

    componentInView(entries) {
        if (entries[0].isIntersecting && !this.state.alreadyMarkedAsRead) {
            this.props.usersConnector.markActivityAsRead(this.props.activity.id);
            this.setState({alreadyMarkedAsRead: true});
        }
    }

    componentWillUnmount() {
        this.observer && this.observer.disconnect();
    }

    render() {
        return null;
    }
}